import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import React from 'react';
import { name } from '../../../utils/helper';

const EmployeeSelect = ({ label, helperText, errorText, fullWidth, employees = [], value = '', onChange, ...other }) => {
  return (<FormControl error fullWidth={fullWidth}>
    {label ? <InputLabel htmlFor="name-error">{label}</InputLabel> : null}
    <Select
      fullWidth={fullWidth}
      value={value ? value.id : ''}
      onChange={(evt) => onChange(employees.find((e) => e.id === evt.target.value))}
      name={label}
      {...other}
    >
      {(employees || []).map((employee) => {
        return (<MenuItem key={employee.id} value={employee.id}>{name(employee)}</MenuItem>);
      })}
    </Select>
    {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    {errorText ? <FormHelperText>{errorText}</FormHelperText> : null}
  </FormControl>);
};

export default EmployeeSelect;



// WEBPACK FOOTER //
// ./src/components/Common/EmployeeSelect/index.js